//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ActivityActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List resources ----------------


//  -- List resources ----------------
export const handleListResources = () => async (dispatch) => {

    try {
        let resources = [];
        const data = await apis.get('resources', `/listResources`);
        if (Array.isArray(data) && data.length > 0) {
            resources = data
        }
        await dispatch(ActivityActions.resourceSuccess(resources));
        return resources;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing resources',
                error,
                module: 'RESOURCES',
                operation: 'LIST_RUBRIC'
            });
        }
        await dispatch(ActivityActions.resourceFail(error));
    }
};
export const handleUpdateResources = (data) => async (dispatch) => {

    try {
        const resources = await apis.put('resources', `/updateResources`, {
            body: data
        });
        if (has(resources, "id")) {
            await dispatch(ActivityActions.updateResourceSuccess(resources));
        }
        // console.log(resources,"===resources===");
        return resources;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating resources',
                error,
                module: 'RESOURCES',
                operation: 'UPDATE_RUBRIC'
            });
        }
        await dispatch(ActivityActions.resourceFail(error));
    }
};
export const handleUpdateVideos = (data, withCloudflareCleanup = true) => async (dispatch) => {
    try {
        const isCloudflareUrl = data?.src && (
            data.src.includes('cloudflarestream.com') || 
            data.src.includes('.m3u8')
        );
        
        const endpoint = withCloudflareCleanup && isCloudflareUrl
            ? `/updateVideos-with-cloudflare-cleanup`
            : `/updateVideos`;
        
        const resources = await apis.put('resources', endpoint, {
            body: data
        });
        if (has(resources, "id")) {
            await dispatch(ActivityActions.updateVideoResourceSuccess(resources));
        }
    
        return resources;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating videos',
                error,
                module: 'RESOURCES',
                operation: 'UPDATE_VOCABULARY'
            });
        }
        await dispatch(ActivityActions.resourceFail(error));
    }
};

export const handleUpdateVideosMeta = (data) => async (dispatch) => {
    try {
        const resources = await apis.put('resources', `/updateVideoMeta`, {
            body: data
        });
        if (has(resources, "id")) {
            await dispatch(ActivityActions.updateVideoResourceSuccess(resources));
        }
    
        return resources;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating videos meta',
                error,
                module: 'RESOURCES',
                operation: 'UPDATE_VOCABULARY_MESSAGE'
            });
        }
        await dispatch(ActivityActions.resourceFail(error));
    }
};

export const handleDeleteResources = (id) => async (dispatch) => {

    try {
        const resources = await apis.del('resources', `/deleteResources/${id}`, {
            
        });
        if (has(resources, "id")) {
            await dispatch(ActivityActions.deleteResourceSuccess(resources));
        }
        // console.log(resources,"===resources===");
        return resources;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting resources',
                error,
                module: 'RESOURCES',
                operation: 'DELETE_RUBRIC'
            });
        }
        await dispatch(ActivityActions.resourceFail(error));
    }
};


export const handleListVideos = () => async (dispatch) => {

    try {
        let videos = []
        const data = await apis.get('resources', `/listVideos`);
        if (Array.isArray(data) && data.length > 0) {
            videos = data
        }
        await dispatch(ActivityActions.videoResourceSuccess(videos));
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing videos',
                error,
                module: 'RESOURCES',
                operation: 'LIST_VOCABULARY'
            });
        }
        await dispatch(ActivityActions.videoResourceFail(error));
    }
};


export const handleListResourcesAndVideo = () => async (dispatch) => {
    dispatch(handleListResources())
    dispatch(handleListVideos())
}

export const handleUpdateVideoSrt = (data) => async (dispatch) => {
    await dispatch(ActivityActions.updateVideoResourceSuccess(data));
}

export const handleDeleteVideo = (id, withCloudflareCleanup = true) => async (dispatch) => {
    try {
        const endpoint = withCloudflareCleanup
            ? `/deleteVideo/${id}`
            : `/deleteResources/${id}`;
        
        const resources = await apis.del('resources', endpoint);
        if (has(resources, "id")) {
            await dispatch(ActivityActions.deleteResourceSuccess(resources));
        }
        return resources;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting video',
                error,
                module: 'RESOURCES',
                operation: 'DELETE_VIDEO'
            });
        }
        await dispatch(ActivityActions.resourceFail(error));
    }
}